var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.2002H3.6C3.03995 9.2002 2.75992 9.2002 2.54601 9.30919C2.35785 9.40506 2.20487 9.55804 2.10899 9.7462C2 9.96012 2 10.2401 2 10.8002V19.2002M15.5 9.2002H18.4C18.9601 9.2002 19.2401 9.2002 19.454 9.30919C19.6422 9.40506 19.7951 9.55804 19.891 9.7462C20 9.96012 20 10.2401 20 10.8002V19.2002M15.5 19.2002V4.4002C15.5 3.28009 15.5 2.72004 15.282 2.29221C15.0903 1.91589 14.7843 1.60993 14.408 1.41818C13.9802 1.2002 13.4201 1.2002 12.3 1.2002H9.7C8.57989 1.2002 8.01984 1.2002 7.59202 1.41818C7.21569 1.60993 6.90973 1.91589 6.71799 2.29221C6.5 2.72004 6.5 3.28009 6.5 4.4002V19.2002M21 19.2002H1M10 5.2002H12M10 9.2002H12M10 13.2002H12",
    stroke: "#4657F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.4237fca838ad2682c9912a5c200d9cd8.svg";
export { ForwardRef as ReactComponent };